<template>
  <v-container fluid class="mx-auto mx-lg-10 mx-md-10">
    <v-row class="mx-lg-10 hidden-sm-and-down">
      <Breadcrumbs :items="breadcrumbs" />
    </v-row>
    <v-row align="start">
      <v-col cols="12" md="3" class="pt-8 mr-lg-10 mr-md-10" v-if="!displaySIM">
        <InfoRow
          :textConfigs="{
            label: 'text-right fontDarkGrey--text font-weight-bold text-h6',
            other: 'fontGrey--text font-weight-normal font-weight-bold text-h6',
          }"
          :fieldLabel="'תומך בתדרים:'"
          :fieldValue="'דור 3 דור 4 ודור 5'"
        />
        <InfoRow
          :textConfigs="{
            label: 'text-right fontDarkGrey--text font-weight-bold text-h6',
            other: 'font-weight-normal font-weight-bold text-h6',
          }"
          :fieldLabel="'תומך באיסים:'"
          :fieldValue="supportsESIM"
          :describeBool="true"
        />
        <InfoRow
          v-if="isKosher"
          :textConfigs="{
            label: 'text-right fontDarkGrey--text font-weight-bold text-h6',
            other: 'fontGrey--text font-weight-normal font-weight-bold text-h6',
          }"
          :fieldLabel="'טלפון כשר:'"
          :fieldValue="isKosher"
          :describeBool="true"
        />
        <InfoRow
          :textConfigs="{
            label: 'text-right fontDarkGrey--text font-weight-bold text-h6',
            other: 'fontGrey--text font-weight-normal font-weight-bold text-h6',
          }"
          :fieldLabel="'ראוטר :'"
          :fieldValue="isRouter"
          :describeBool="true"
        />
        <InfoRow
          :textConfigs="{
            label: 'text-right fontDarkGrey--text font-weight-bold text-h6',
            other: 'fontGrey--text font-weight-normal font-weight-bold text-h6',
          }"
          :fieldLabel="'נמערכת הפעלה:'"
          :fieldValue="os"
        />
        <InfoRow
          :textConfigs="{
            label: 'text-right fontDarkGrey--text font-weight-bold text-h6',
            other: 'fontGrey--text font-weight-normal font-weight-bold text-h6',
          }"
          :fieldLabel="'אפליקצית שיחות:'"
          :fieldValue="hasCallsApp"
          :describeBool="true"
        />
        <p class="text-right fontDarkGrey--text font-weight-bold text-h6 pr-6">
          סימים מותקנים:
        </p>
        <v-btn
          v-if="mobileInfo"
          class="fontDarkGrey--text font-weight-bold text-h6 pr-6"
          plain
          text
          x-large
          @click="displaySIM = !displaySIM"
        >
          {{ mobileInfo.esim ? "eSIM" : "SIM" }}
          <span>
            {{ maskSimDisplay(mobileInfo.sim_data.iccid) }}
          </span>
        </v-btn>

        <!-- v-for="sim, i in mobileInfo.sim_data" :key="i" -->
      </v-col>
      <v-col cols="12" md="3" class="text-center" v-if="!displaySIM">
        <p class="fontGrey--text font-weight-bold h4">Apple</p>
        <p class="fontGrey--text h5">iPhone 11</p>
        <v-img :src="phoneMock"></v-img>
      </v-col>
      <v-col v-else cols="12" md="6" class="pt-0 mr-lg-10 mr-md-10">
        <SimDetails
          :simDetails="mobileInfo.sim_data"
          :isEsim="mobileInfo.esim"
          :mobileInfo="mobileInfo"
        />
        <!-- change when device recognition is supported -->
      </v-col>
      <v-col cols="12" md="4">
        <ButtonsGroup :items="links" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import apiCalls from "@/mixins/apiCalls.js";
import fetchUsers from "@/mixins/fetchUsers.js";
import Breadcrumbs from "@/components/CommonComponents/Selects/Breadcrumbs";
import isNil from "lodash/isNil";
import chunk from "lodash/chunk";
import join from "lodash/join";
import map from "lodash/map";

import md5 from "js-md5";
import generateString from "@/components/Account/accountUtils/utils.js";
const BRAND_TOKEN = "da2ab7d7-810a-41b2-be51-6547d6fdc841";
const BASE_URI_ACTIONS =
  "https://widelyapp-api-01.x2one.com:3001/api/v1/temp_prev";

export default {
  name: "UserDevice",
  mixins: [fetchUsers, apiCalls],
  components: {
    Breadcrumbs,
    ButtonsGroup: () => import('@/components/CommonComponents/Selects/ButtonsGroup'),
    SimDetails: () => import("@/components/User/SimDetails"),
    InfoRow: () => import("@/components/CommonComponents/InfoRow"),
  },
  data() {
    return {
      phoneMock: require("../../../assets/images/apple11.jpeg"),
      mobileInfo: null,
      displayItems: null,
      loaded: false,
      displaySIM: false,
      redirected: false,
      supportsESIM: true,
      isKosher: false,
      isRouter: false,
      os: "iOS 15",
      hasCallsApp: false,
      deviceInfo: null
    };
  },
  mounted() {
    // this.fetchDeviceInfo()
    if (this.didRedirect) this.displaySimDetails();
    else this.fetchUserEndpoints();
  },
  watch: {
    displayItems: {
      handler(val) {
        if (!isNil(val)) this.fetchSimDetails();
        return;
      },
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.user.profile,
      didRedirect: (state) => state.user.didRedirect,
      didRedirectNumber: (state) => state.user.didRedirectNumber,
      adminAccount: state => state.account.adminAccount,
      account: state => state.account
    }),

    breadcrumbs() {
      return this.accountOwner
        ? [
            {
              text: "חזרה לעמוד ראשי",
              link: true,
              exact: true,
              disabled: false,
              to: {
                name: "profile",
                params: {
                  id: this.account.domain_id,
                },
              },
            },

            {
              text: `מנוי: ${this.user.profile.name}`, // 'מנוי',
              disabled: false,
              link: true,
              exact: true,
              to: {
                name: "user-profile",
                params: {
                  id: this.user.domain_user_id,
                },
              },
            },
            {
              text: "ציוד קצה",
              disabled: true,
            },
          ]
        : [
            {
              text: `מנוי: ${this.user.profile.name}`, // 'מנוי',
              disabled: false,
              link: true,
              exact: true,
              to: {
                name: "user-profile",
                params: {
                  id: this.user.profile.domain_user_id,
                },
              },
            },
            {
              text: "ציוד קצה",
              disabled: true,
            },
          ];
    },
    links() {
      return [
        {
          label: "$vuetify.user.userOptionButtons.numbers", 
          icon: "mdi-account-box-multiple",
          link: `/user/${this.$route.params.id}/dids`,
        },

        {
          label: "$vuetify.accounts.pageTexts.options.abroad",
          icon: "icon-globe",
          link: `/user/${this.$route.params.id}/roaming/subscriptions`, 
        },
        {
          label: "שירותים נוספים", 
          icon: "mdi-folder-star-multiple-outline",
          link: `/user/${this.$route.params.id}/callSettings/callReports`,
        },
        {
          label: "$vuetify.user.userOptionButtons.calls", 
          icon: "mdi-phone",
          link: `/user/${this.$route.params.id}/callSettings`,
        },
      ];
    },
  },
  methods: {
    ...mapActions(["setDidRedirect", "setRedirectDIDnumber"]),
    async fetchSimDetails() {
      this.mobileInfo = await this.fetchMobileInfo(
        this.displayItems[0].endpoint_id
      );
      return;
    },
    async fetchDeviceInfo() {
      const appAction = false;
      const hash = generateString(10);
 
      const functionName = "get_device_info";
    
      const reqBody = {
        auth: {
          auth_id:  this.account.account.auth_id,
          hash: hash,
          auth: appAction
           ? md5(BRAND_TOKEN + hash)
            : md5(this.account.account.token + md5(BRAND_TOKEN + hash)),
        },
        func_name: functionName,
        data: {
          imei: '359449126116744'//this.user.imei,
        }
      }
      try {
        const response = await this.$axios.post(BASE_URI_ACTIONS, reqBody);
        console.log('res ', response);
        this.deviceInfo = response.data
      } catch (e) {
        console.error(e);
      }
    },
    maskSimDisplay(simString) {
      let chunks = chunk(simString, 5);
      let arr = map(chunks, (el) => {
        return join(el, "");
      });
      return join(arr, " ");
    },
    async displaySimDetails() {
      this.mobileInfo = await this.fetchMobileInfo(
        this.user.active_subscriptions[0].endpoint_id
      );
      this.redirected = true;
      this.displaySIM = true;
    },
  },
  beforeDestroy() {
    this.$store.dispatch("setRedirectDIDnumber", null);
    this.$store.dispatch("setDidRedirect", false);
  },
};
</script>
